import { ContentRow } from 'components/ThemeComponents';
import { 
  Form,
  Input,
  Card,
  Select
} from 'antd';
import {
  validateMessages
} from 'helpers/validationHelper';

export default function AccountForm({ form, fromSource }) {
  return (
    <ContentRow capped>
      <Form
        form={form}
        name="account_form"
        layout="vertical"
        validateMessages={validateMessages}
      >
        <Card
          title={'Account Information'}
          style={{ 
            minWidth: '300px',
            width: '100%'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px'
            }}
          >
            <div style={{ display: 'flex', width: '100%', gap: '16px' }}>
              <Form.Item
                label="Full Name"
                name="name"
                rules={[{ required: true, min: 2, max: 50 }]}
                style={{ flex: 1 }}
              >
                <Input placeholder="Enter full name" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, type: 'email' }]}
                style={{ flex: 1 }}
              >
                <Input placeholder="Enter email address" />
              </Form.Item>

              <Form.Item
                label="Phone Number"
                name="phone_number"
                style={{ flex: 1 }}
              >
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </div>

            <div style={{ display: 'flex', width: '100%', gap: '16px' }}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, min: 8, message: 'Password must be at least 8 characters' }]}
                style={{ flex: 1 }}
                hasFeedback
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                dependencies={['password']}
                rules={[
                  { required: true, message: 'Please confirm your password' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject('The two passwords do not match');
                    },
                  }),
                ]}
                style={{ flex: 1 }}
                hasFeedback
              >
                <Input.Password placeholder="Confirm your password" />
              </Form.Item>
              {
                fromSource === 'ai_store' && (
                  <Form.Item
                    label="domain"
                    name="domain"
                    rules={[{ required: true, min: 2, max: 50 }]}
                    style={{ flex: 1 }}
                  >
                    <Input placeholder="Enter domain" />
                  </Form.Item>
                )
              }
            </div>
          </div>
        </Card>
      </Form>
    </ContentRow>
  );
}